const searchTriggersArticle = document.querySelector('[data-search-trigger-articles]');
const formArticle = document.querySelector('.form_almanac');
const searchErrorArticle = document.querySelector('[data-search-error-article]');
const defaultSearchArticle = document.querySelector('.default-search-article');
const searchInputArticle = searchTriggersArticle.querySelector('input[type="search"]');
const searchResultsArticle = document.querySelector('#predictive-search-article');
const clearBtnArticle = formArticle.querySelector('.close_svg');
const all_blogs = document.querySelector('.all_blogs');
const blog_categories = document.querySelectorAll('.almanac_blog_category_link');

searchTriggersArticle.addEventListener('click', (ev) => {
    ev.preventDefault();

    searchInputArticle.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    });

    formArticle.addEventListener('submit', (e) => {
        e.preventDefault();
    });

    function truncate( str, n, useWordBoundary ){
        if (str !== undefined) {
            const subString = str.substr(0, n-1); // the original check
            console.log(subString);
            return (useWordBoundary 
              ? subString.substr(0, subString.lastIndexOf(" ")) 
              : subString) + "&hellip;";
        }
      };

    function predictiveSearch(e) {
        setTimeout(() => {
            const searchTerm = searchInputArticle.value.trim();
            
            if (searchTerm.length > 0) {
                defaultSearchArticle.style.display = 'none';
                searchResultsArticle.style.display = 'grid';
                clearBtnArticle.style.display = 'block';
            } 
            
            
            if (searchTerm.length === 0) {
                defaultSearchArticle.style.display = 'flex';
                searchResultsArticle.style.display = 'none';
                searchResultsArticle.innerHTML = '';
                clearBtnArticle.style.display = 'none';
            }
            
//             all_blogs.addEventListener('click', (e) => {
//                 if (searchTerm.length > 0) {
//                     defaultSearchArticle.style.display = 'flex';
//                     searchResultsArticle.style.display = 'none';
//                     searchResultsArticle.innerHTML = '';
//                     clearBtnArticle.style.display = 'none';
//                 }

//             });

            blog_categories.forEach((category) => {
                category.addEventListener('click', (e) => {
                    if (searchTerm.length > 0) {
                        defaultSearchArticle.style.display = 'flex';
                        searchResultsArticle.style.display = 'none';
                        searchResultsArticle.innerHTML = '';
                        clearBtnArticle.style.display = 'none';
                    }
                });
            });
    
            fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=article&resources[options][fields]=title,body,tag`)

            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                throw error;
              }
              return response.json();
            })

            .then((suggestions ) => {
                setTimeout(() => {
                searchResultsArticle.innerHTML = '';
                const articleSuggestions = suggestions.resources.results.articles;
                
                if(articleSuggestions.length === 0) {
                    searchErrorArticle.style.display = 'block';
                    defaultSearchArticle.style.display = 'flex';
                    searchResultsArticle.style.display = 'none';
                    searchErrorArticle.classList.add('search-heading');
                    searchErrorArticle.innerHTML = `Your search for “${searchTerm}” didn’t return any results.`;
                } else {
                    searchErrorArticle.style.display = 'none';
                    defaultSearchArticle.style.display = 'none';
                                                
                    articleSuggestions.forEach((article, i) => {
                        let list_element = document.createElement('div');
                        list_element.classList.add('list_element');

                        let body = truncate(articleSuggestions[i].body, 125, true);
                        // let body = articleSuggestions[i].body.length > 200 ? articleSuggestions[i].body.substring(0, 125) + '...' : articleSuggestions[i].body;
                        const highlight = articleSuggestions[i].title.replace(new RegExp(searchTerm, 'gi'), `<span class="highlight">${searchTerm}</span>`);
                        // const highlightBody = body.replace(new RegExp(searchTerm, 'gi'), `<span class="highlight">${searchTerm}</span>`);
                          
                        list_element.innerHTML = `
                        <a href="${articleSuggestions[i].url}">
                            <div>
                                <img src="${articleSuggestions[i].image}" class="imgs lazyload article_almanac_img">
                            </div> 
                            <div class="article_content">
                                <h3 class="article_title">${highlight}</h3>
                                <p>${body}</p>
                            </div>
                        </a>
                    `;
                    searchResultsArticle.appendChild(list_element);
                    });
          
                }
                }, 450);


            })
           
            .catch((error) => {
                console.log(error);
              throw error;
            }); 
            }, 300);

    }
    searchInputArticle.addEventListener('input', (e) => {
        predictiveSearch(e);

    });

    clearBtnArticle.addEventListener('click', (e) => {
        e.preventDefault();
        searchInputArticle.value = '';
        defaultSearchArticle.style.display = 'flex';
        predictiveSearch(e);
    });
    
});